/* ============================================================
   BELO PDP — page behaviour (product.6in1.json sections)
   Vanilla JS, no frameworks. Add-to-cart itself is handled by
   the theme's component-product-form.js — this file only does:
   (a) offer-box selection (subscription vs one-time) + syncing
       the hidden selling_plan input,
   (b) frequency-select price updates from data attributes,
   (c) sticky-bar show/hide via IntersectionObserver on the
       hero buy-box section, and sticky price text updates.
   Idempotent via window.__beloPdpInit.
   ============================================================ */
(function () {
  'use strict';

  function initBuyBox(buyBox) {
    var planInput = buyBox.querySelector('[data-belo-selling-plan-input]');
    var freqSelect = buyBox.querySelector('[data-belo-plan-freq]');
    var radios = buyBox.querySelectorAll('[data-belo-purchase-radio]');
    var offers = buyBox.querySelectorAll('[data-belo-offer]');
    var firstPriceEl = buyBox.querySelector('[data-belo-first-price]');
    var recurringPriceEl = buyBox.querySelector('[data-belo-recurring-price]');
    var savePctEl = buyBox.querySelector('[data-belo-save-pct]');
    var oneTimePrice = buyBox.getAttribute('data-one-time-price') || '';

    function selectedOffer() {
      var checked = buyBox.querySelector('[data-belo-purchase-radio]:checked');
      if (!checked) return 'subscription';
      var offer = checked.closest('[data-belo-offer]');
      return offer ? offer.getAttribute('data-belo-offer') : 'subscription';
    }

    function currentPlanOption() {
      if (!freqSelect) return null;
      return freqSelect.options[freqSelect.selectedIndex] || null;
    }

    function updateStickyPrice() {
      // Only the HERO buy box drives the sticky-bar price — the sticky
      // CTA anchors to the hero form, so its price must mirror that
      // form's state, not the close box's.
      if (buyBox.getAttribute('data-belo-context') !== 'hero') return;
      var stickyPriceEls = document.querySelectorAll('[data-belo-sticky-price]');
      if (!stickyPriceEls.length) return;
      var text;
      if (selectedOffer() === 'subscription') {
        var option = currentPlanOption();
        var firstPrice = option ? option.getAttribute('data-first-price') : '';
        text = firstPrice + ' first order · subscription';
      } else {
        text = oneTimePrice + ' one-time';
      }
      stickyPriceEls.forEach(function (el) { el.textContent = text; });
    }

    function syncSellingPlan() {
      if (!planInput) return;
      if (selectedOffer() === 'subscription') {
        var option = currentPlanOption();
        planInput.value = option ? (option.getAttribute('data-selling-plan-id') || '') : '';
      } else {
        // Blank value: theme JS disables blank inputs pre-submit, so
        // one-time orders omit selling_plan entirely.
        planInput.value = '';
      }
    }

    function syncSelectedStates() {
      offers.forEach(function (offer) {
        var radio = offer.querySelector('[data-belo-purchase-radio]');
        offer.classList.toggle('is-selected', !!(radio && radio.checked));
      });
    }

    function updateDisplayedPlanPrices() {
      var option = currentPlanOption();
      if (!option) return;
      if (firstPriceEl) firstPriceEl.textContent = option.getAttribute('data-first-price') || '';
      if (recurringPriceEl) recurringPriceEl.textContent = option.getAttribute('data-recurring-price') || '';
      if (savePctEl) savePctEl.textContent = 'save ' + (option.getAttribute('data-save-pct') || '') + '%';
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        syncSelectedStates();
        syncSellingPlan();
        updateStickyPrice();
      });
    });

    if (freqSelect) {
      freqSelect.addEventListener('change', function () {
        // Choosing a frequency implies subscribing — make sure the
        // subscription offer is the selected one.
        var subOffer = buyBox.querySelector('[data-belo-offer="subscription"]');
        var subRadio = subOffer && subOffer.querySelector('[data-belo-purchase-radio]');
        if (subRadio && !subRadio.checked) subRadio.checked = true;
        syncSelectedStates();
        updateDisplayedPlanPrices();
        syncSellingPlan();
        updateStickyPrice();
      });
    }

    // Initial sync (covers bfcache restores / re-rendered sections).
    syncSelectedStates();
    syncSellingPlan();
    updateStickyPrice();
  }

  function initStickyBar() {
    var hero = document.querySelector('.belo-pdp--hero-buybox');
    var bar = document.getElementById('beloStickyBar');
    if (!hero || !bar || !('IntersectionObserver' in window)) return;
    if (bar.__beloObserved) return; // one observer per bar
    bar.__beloObserved = true;
    var io = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      bar.classList.toggle('show', !entry.isIntersecting);
    }, { threshold: 0 });
    io.observe(hero);
  }

  function initGallery(hero) {
    if (hero.__beloGallery) return;
    hero.__beloGallery = true;
    var main = hero.querySelector('[data-belo-gallery-main]');
    var thumbs = hero.querySelectorAll('[data-belo-gallery-thumb]');
    if (!main || !thumbs.length) return;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.getAttribute('data-full-src');
        if (!src || btn.classList.contains('is-active')) return;
        thumbs.forEach(function (b) {
          b.classList.remove('is-active');
          b.removeAttribute('aria-current');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-current', 'true');
        var apply = function () {
          main.src = src;
          var ss = btn.getAttribute('data-full-srcset');
          if (ss) { main.setAttribute('srcset', ss); } else { main.removeAttribute('srcset'); }
          var alt = btn.getAttribute('data-full-alt');
          if (alt !== null) main.alt = alt;
          main.classList.remove('is-fading');
        };
        if (reduceMotion && reduceMotion.matches) { apply(); return; }
        main.classList.add('is-fading');
        window.setTimeout(apply, 180); // matches the CSS fade-out duration
      });
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-belo-buy-box]').forEach(function (buyBox) {
      // Per-element guard: safe across the three sections that each
      // load this file and across theme-editor section re-renders.
      if (buyBox.__beloInit) return;
      buyBox.__beloInit = true;
      initBuyBox(buyBox);
    });
    (root || document).querySelectorAll('.belo-pdp--hero-buybox').forEach(initGallery);
    initStickyBar();
  }

  function setup() {
    if (window.__beloPdpSetup) return;
    window.__beloPdpSetup = true;
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }
    // Theme editor: re-init when a section is (re)rendered.
    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target);
      initStickyBar();
    });
  }

  setup();
})();
